import React from 'react';
import { Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

function DDChart({ dataClass, ddData }) {
    if (!ddData) return null;
    const dataStr = ddData.data; // '...; 0.0, 0.0221; 0.1, 0.2311;' 형태의 센서 데이터
    const dataArr = dataStr.split(';');
    dataArr.pop();
    const arrayConvertedDataArr = dataArr.map(el => el.split(','));
    const data = arrayConvertedDataArr.map((el, idx) => {
        const retObj = { "id": idx };
        for (let i = 0; i < el.length; i++) {
            if (i === 0) {
                retObj["time"] = parseFloat(el[i]) * 10;
            } else {
                retObj[`data${i}`] = parseFloat(el[i]);
            };
        };
        return (retObj);
    })
    const colorArr = ["#0A2B83", "#45BFCE"];
    const aniDura = 500;
    const data1Arr = data.map(el => parseFloat(el.data1));
    const data2Arr = data.map(el => parseFloat(el.data2 ?? 0));
    const timeArr = data.map(el => parseFloat(el.time));
    const maxY = Math.ceil(Math.max(...data1Arr, ...data2Arr));
    const minY = Math.floor(Math.min(...data1Arr, ...data2Arr));
    const tick = Math.ceil((maxY - minY) / 5);
    const maxDomain = 50;
    const minDomain = 0;
    const endTime = timeArr[timeArr.length - 1];

    function makeNiceTicks10Step(maxTickCount = 10, stepBase = 10, minVal, maxVal) {
        // 최소/최대값을 10의 배수로 반올림
        let min = Math.floor(minVal / stepBase) * stepBase;
        let max = Math.ceil(maxVal / stepBase) * stepBase;

        let range = max - min;
        let step = stepBase;

        // tick 수가 너무 많으면 step을 2배씩 늘림
        while (range / step > maxTickCount - 1) {
            step *= 2;
            min = Math.floor(minVal / step) * step;
            max = Math.ceil(maxVal / step) * step;
            range = max - min;
        }

        const ticks = [];
        for (let v = min; v <= max; v += step) ticks.push(v);

        return { domain: [min, max], ticks };
    }

    const rawMin = Math.min(...data1Arr, ...data2Arr);
    const rawMax = Math.max(...data1Arr, ...data2Arr);

    const { domain: dynDomain, ticks: dynTicks } = makeNiceTicks10Step(8, 10, 0, rawMax < 50 ? 50 : rawMax);


    function nextMultipleOf4(n) {
        // 먼저 n보다 큰 정수부터 시작
        let next = Math.ceil(n * 10);

        // 4로 나눠 떨어질 때까지 증가
        while (next % 4 !== 0) {
            next++;
        }

        return next / 10;
    }


    const lastTick = nextMultipleOf4(endTime)

    let xTickArr = [0.0];
    for (let i = 1; i < 5; i++) {
        xTickArr.push(parseFloat(lastTick / 4 * i));
    }

    xTickArr.sort();

    const changedData = [...data, { time: Math.ceil(endTime * 2) / 2 }];
    const filteredData = changedData.map(d => ({
        ...d,
        data1: d.data1 < 0 ? 0 : d.data1,
        data2: d.data2 < 0 ? 0 : d.data2,
    }));
    return (
        <ResponsiveContainer>
            <LineChart data={dataClass === '원자재' ? changedData : filteredData}>
                <YAxis
                    axisLine={true}
                    type="number"
                    ticks={dataClass === '원자재' ? [-20, -10, 0, 10, 20] : dynTicks}  // ✅ Y축 눈금 고정
                    tickSize={5}
                    width={38}
                    tickMargin={5}
                    domain={dataClass === '원자재' ? [-20, 20] : dynDomain}
                    interval={0}
                    allowDataOverflow={false}
                    tick={{ fontSize: 12 }}
                />
                <XAxis
                    dataKey={"time"}
                    type='number'
                    axisLine={true}
                    height={14}
                    tickMargin={3}
                    tickSize={3}
                    tickCount={endTime < 5 ? Math.floor(endTime) + 1 : 5}
                    interval={"preserveStartEnd"}
                    domain={[0.0, endTime]}
                    // ticks={xTickArr}
                    allowDecimals={true}
                    tickFormatter={(xTick) => parseFloat(xTick / 10).toFixed(1)}
                    tick={{ fontSize: 12 }}
                />
                <Line
                    dataKey={`data1`}
                    stroke={colorArr[0]}
                    dot={false}

                />
                <Line
                    dataKey={`data2`}
                    stroke={colorArr[1]}
                    dot={false}
                />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default DDChart;